import { typo } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { TypographyPrimitive, type TypographyPrimitiveProps } from "../primitives/TypographyPrimitive";

const styles = stylex.create({
	root: {
		fontSize: typo.bodyDefaultFontSize,
		fontWeight: typo.bodyDefaultFontWeight,
		lineHeight: typo.bodyDefaultLineHeight,
	},
});

export const BodyDefault = ({ render, ...props }: TypographyPrimitiveProps) => {
	return <TypographyPrimitive render={render} {...props} sx={[styles.root, props.sx]} />;
};
